// Ingesta del menú de papel con IA. Espejo de Core/DTOs/MenuIngestDtos.cs.

/** Confianza declarada por el modelo sobre un campo leído. */
export type MenuFieldConfidence = 'High' | 'Low';

/** De dónde salió el renglón que se va a crear. */
export type MenuDraftItemSource = 'Ia' | 'Editado' | 'Agregado';

/**
 * Marcas sobre un renglón. Ninguna detiene nada: existen para contestar
 * "¿qué reviso primero?" en una lista de ochenta renglones, que es el
 * problema real de la pantalla de revisión.
 */
export const MENU_DRAFT_FLAGS = {
  yaExiste: 'ya-existe',
  duplicado: 'duplicado',
  precioIlegible: 'precio-ilegible',
  precioFueraDeRango: 'precio-fuera-de-rango',
  variantePorTamano: 'variante-por-tamano',
  textoRecortado: 'texto-recortado',
} as const;

export type MenuIngestStatus = 'borrador' | 'confirmada';

export type MenuPageAnalysisStatus = 'ok' | 'unreadable' | 'unavailable';

export interface MenuDraftItem {
  id: string;
  name: string;
  description: string | null;
  /** null = no se pudo leer. NO es cero: un platillo gratis es otra cosa. */
  price: number | null;
  categoryName: string;
  nameConfidence: MenuFieldConfidence;
  priceConfidence: MenuFieldConfidence;
  source: MenuDraftItemSource;
  pageNumber: number;
  flags: string[];
  /** Excluir no es borrar: el renglón sigue visible y se puede volver a marcar. */
  excluded: boolean;
}

export interface MenuIngestPage {
  id: string;
  pageNumber: number;
  analysisStatus: MenuPageAnalysisStatus;
  note: string | null;
  itemsRead: number;
  fileName: string;
  sizeBytes: number;
}

export interface MenuIngest {
  id: string;
  status: MenuIngestStatus;
  pages: MenuIngestPage[];
  items: MenuDraftItem[];
  createdAt: string;
  expiresAt: string;
  confirmedAt: string | null;
}

/** Lo que devuelve confirmar: el mismo shape que el import por CSV. */
export interface MenuIngestConfirmResult {
  totalRows: number;
  successCount: number;
  errorCount: number;
  categoriesCreated: number;
  errors: {
    rowNumber: number;
    rowData: Record<string, string>;
    errors: string[];
  }[];
}
